"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMediaRecorderDispatch = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const AgoraConsole_1 = require("../util/AgoraConsole");
class IMediaRecorderDispatch {
    constructor(engine) {
        this._engine = engine;
    }
    // @ts-ignore
    setMediaRecorderObserver_e1f7340(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaRecorder_setMediaRecorderObserver_e1f7340 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startRecording_94480b3(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('MediaRecorder_startRecording_94480b3 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopRecording() {
        AgoraConsole_1.AgoraConsole.warn('MediaRecorder_stopRecording not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.IMediaRecorderDispatch = IMediaRecorderDispatch;
